import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSelect,{staticClass:"select-role px-4 font-weight-bold body-2 rounded-sm",attrs:{"items":_vm.programRoles,"item-text":function (ref) {
	var role = ref.role;

	return ("Perfil " + (_vm.translateRoles(role)));
},"item-value":"role","background-color":"#808080","height":"45px"},on:{"change":_vm.changeUserRole},model:{value:(_vm.roleSelected),callback:function ($$v) {_vm.roleSelected=$$v},expression:"roleSelected"}})}
var staticRenderFns = []

export { render, staticRenderFns }